import ApiService from "@/api.service";
import API from "@/API";

export const GET_LIST_POSITION = "GET_LIST_POSITION";
export const GET_DETAIL_POSITION = "GET_DETAIL_POSITION";
export const UPDATE_POSITION = "UPDATE_POSITION";
export const SAVE_POSITION = "SAVE_POSITION";
export const DELETE_POSITION = "DELETE_POSITION";
export const SET_LIST_POSITION = "SET_LIST_POSITION";
export const SET_DETAIL_POSITION = "SET_DETAIL_POSITION";


const state = {
    position: [],
    positionDetail: []
};

const getters = {
    position(state) {
        return state.position;
    },
    positionDetail(state) {
        return state.positionDetail;
    },


};

const actions = {
    [GET_LIST_POSITION](context) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_LIST_POSITION}`).then(({data}) => {
                if (data.status) {
                    context.commit(SET_LIST_POSITION, data);
                }
                resolve(data);
            });
        });
    },
    [GET_DETAIL_POSITION](context,id) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_DETAIL_POSITION}/${id}`).then(({data}) => {
                if (data.status) {
                    context.commit(SET_DETAIL_POSITION, data);
                }
                resolve(data);
            });
        });
    },
    [SAVE_POSITION](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.SAVE_POSITION}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [UPDATE_POSITION](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.update(`${API.UPDATE_POSITION}`, payload.id, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [DELETE_POSITION](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`${API.DELETE_POSITION}`,id)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

};

const mutations = {
    [SET_LIST_POSITION](state, data) {
        state.position = data.data;
    },
    [SET_DETAIL_POSITION](state, data) {
        state.positionDetail = data.data;
    },


};

export default {
    state,
    actions,
    mutations,
    getters
};